/** Maximum number of dots for the scatterplot */
export const MAX_DOTS = 5000
/** Number of dots for when the underlay should be triggered */
export const UNDERLAY_THRESHOLD = 3000

export const PROGRESSIVE_THRESHOLD = 3000
